import React from 'react';
import PropTypes from 'prop-types';
import SignInForm from './SignInForm';
import './SignInModal.css';

const SignInModal = ({ onClose }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>×</button>
        <SignInForm onClose={onClose} isModal={true} />
      </div>
    </div>
  );
};

SignInModal.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default SignInModal; 